import { Pipe, PipeTransform } from '@angular/core';

import { StringUtils } from 'tiime-expert-utils';

import { BusinessUnit } from '@models/business-unit';

@Pipe({
  name: 'businessUnitsWithoutArchived',
  standalone: true
})
export class BusinessUnitsWithoutArchivedPipe implements PipeTransform {
  transform(businessUnits: BusinessUnit[], exceptBusinessUnitId?: number, exceptFilter?: string): BusinessUnit[] {
    if (!businessUnits?.length) {
      return [];
    }

    return businessUnits.filter(
      (businessUnit: BusinessUnit) =>
        this.withoutArchivedCondition(businessUnit) ||
        this.exceptBusinessUnitIdCondition(businessUnit, exceptBusinessUnitId) ||
        this.exceptFilterCondition(businessUnit, exceptFilter)
    );
  }

  private withoutArchivedCondition(businessUnit: BusinessUnit): boolean {
    return !businessUnit.archivedAt;
  }

  private exceptBusinessUnitIdCondition(businessUnit: BusinessUnit, businessUnitId: number): boolean {
    if (!businessUnitId) {
      return false;
    }

    return businessUnit.id === businessUnitId;
  }

  private exceptFilterCondition(businessUnit: BusinessUnit, filter: string): boolean {
    if (!filter) {
      return false;
    }

    return StringUtils.normalizeToLowerCase(businessUnit.name) === StringUtils.normalizeToLowerCase(filter);
  }
}
